
import { View } from 'backbone';
import eventBus         from 'EventBus.js';

import nameTemplate from 'report/properties/main/line-chart-type.ejs';


class MainLineChartTypeView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change #lineChartType' : 'updateSelectAttributes'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        this.model.set( propName, propVal );
    }



    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        $(`select[name="lineChartType"] option[value='${this.model.get('lineChartType')}']`).prop('selected', true);
        }
        this.delegateEvents();
        return this;
    }

}

export default MainLineChartTypeView;
